
  <kendo-dialog title="{{'_Shared_ModelPopUp_Transfer_Assist_Other_Title_Text_' | translate }}" *ngIf="dialogOpened" (close)="close()">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>

    <div class="col-md-12 form-group">
      <p>{{'_Shared_ModelPopUp_Transfer_Assist_Other_Body_Text_' | translate}}</p>
    </div>
    <div class="col-md-12 form-group" *ngIf="impersonateAssistDetail != null">
      <label class="lbl-modal">{{'_Shared_ModelPopUp_Transfer_Assist_Other_Transfer_To_Text_' | translate}} ({{'_General_All_Text_' | translate}})</label>
      <!-- {{transferAllDisable}} -->
      <select (change)="bulkUserChange($event)" 
      class="form-control" [disabled]="impersonateAssistDetail!.availableUsers.length==0 || transferAllDisable" [(ngModel)]="impersonateAssistDetail.impersonatedByUserId">
      <option value="0"><span *ngIf="impersonateAssistDetail!.availableUsers.length > 0">{{'_Lobby_Impersonate_Select_User_Text_' | translate}}</span><span *ngIf="impersonateAssistDetail?.availableUsers?.length==0">{{'_General_No_Users_Available_Message_Text_' | translate}}</span></option>
      <option *ngFor="let availableUser of impersonateAssistDetail?.availableUsers" [value]="availableUser.userId">
        {{availableUser.userName}}</option>
    </select>
      
    </div>
    

    <div class="col-md-12 form-group">
      <div class="tbl-impersonate-scrollable">
      <table width="100%" class="tbl-imposonate-users">
        <tr>
          <th>{{'_General_Location_Text_' | translate }}</th>
          <th>{{'_General_Visitor Name_Text_' | translate }}</th>
          <th>{{'_Shared_ModelPopUp_Transfer_Assist_Other_Transfer_To_Text_' | translate }}</th>
        </tr>
        
        <tr *ngFor="let data of impersonateAssistDetail?.availableOptions">
          <td>{{data.locationName}}</td>
          <td>{{data.visitorName}}</td>
          <td>           
            <select class="form-control" (change)="optionUserChange()" [(ngModel)]="data.impersonatedByUserId" [disabled]="!(data.availableUsers | impersonationtransferselectdisable:data.impersonatedByUserId)" >
              <option value="0"><span *ngIf="(data.availableUsers | impersonationtransferselectdisable:data.impersonatedByUserId)">{{'_Lobby_Impersonate_Select_User_Text_' | translate}}</span><span *ngIf="!(data.availableUsers | impersonationtransferselectdisable:data.impersonatedByUserId)">{{'_General_No_Users_Available_Message_Text_' | translate}}</span></option>
              <option *ngFor="let availableUser of data.availableUsers | impersonationtransferfilter:data.impersonatedByUserId"   [ngValue]="availableUser.userId"> {{availableUser.userName}}</option>
             
            </select>
          </td>
        </tr> 
      
        
      </table>
    </div>
    </div>

    <!-- Button Panel -->
    <div class="cc-btn-panel multiple-btn-panel">
      <div>
        <button type="button" id="closeBtn" class="btn btn-secondary" (click)="close()">{{'_General_Button_Close_Text_' | translate}}</button>
        <button type="button" id="saveBtn" class="btn btn-primary" (click)="postImpersonateTransferData()" [disabled]="!isFormValid">{{'_General_Transfer_Text_' | translate}}</button>
      </div>

    </div>

  </kendo-dialog>

  
